import { InputDropdown } from "@czi-sds/components";
import styled from "@emotion/styled";

export const CellTypeInputDropdown = styled(InputDropdown)`
  position: absolute;
  margin-left: -8px;
  margin-top: -2px;
  z-index: 14;
  .styled-label {
    color: #111418;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.084px;
  }
`;
